//router
import { createContext, useEffect, useState } from "react";
//header
import Header from "./components/partials/dashboard/HeaderStyle/header";
//subheader
import SubHeader from "./components/partials/dashboard/HeaderStyle/sub-header";
import Sidebar from "./components/partials/dashboard/SidebarStyle/sidebar";
import Footer from "./components/partials/dashboard/FooterStyle/footer";
import Loader from "./components/Loader";
import PublicRoutes from "./Variables1/PublicRoutes";
import PrivateRoutes from "./Variables1/PrivateRoutes";
//scss
import "./assets/scss/hope-ui.scss";
import "./assets/scss/dark.scss";
import "./assets/scss/rtl.scss";
import "./assets/scss/custom.scss";
import "./assets/scss/customizer.scss";
import Cookies from "js-cookie";

export const Context = createContext();

function App() {
  const [isAuth, setIsAuth] = useState(null);
  const [refreshSideBar,setRefreshSideBar] = useState(false);

  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
    setIsAuth(true);
    } else {
    setIsAuth(false);
    }
  }, []);

  if (isAuth === null) {
    return <Loader />;
  }

  return (
    <Context.Provider value={[isAuth, setIsAuth]}>
      <div className="App">
        {isAuth ? (
          <>
            <Sidebar setRefreshSideBar={setRefreshSideBar} refreshSideBar={refreshSideBar}/>
            <main className="main-content">
              <Header />
              <SubHeader />
              <div className="py-0 container-fluid content-inner mt-n5">
                <PrivateRoutes setRefreshSideBar={setRefreshSideBar}/>
              </div>
              <Footer />
            </main>
          </>
        ) : (
          <PublicRoutes />
        )}
      </div>
    </Context.Provider>
  );
}

export default App;
